export default __webpack_public_path__ + "static/media/54.43d22555.png";